// ----------- estils jwplayer del antic portal -----------
// TODO?? faltaria portar https://statics.3cat.cat/skinplayer/jwplayer8/ccma/ccma.css del portal
// import 'styles/modul-rmp.css';
// import 'styles/ccma.css';
// --------------------------------------------
import { MsalProvider } from '@azure/msal-react';
import { getDynamicComponents } from 'components';
import AvisCookies from 'components/3cat/AvisCookies';
import Modal from 'components/3cat/Modal';
import ErrorBoundary from 'components/3cat/ErrorBoundary';
import Loading from 'components/3cat/Loading';
import Onboarding from 'components/3cat/Onboarding';
import ServicesListener from 'components/ServicesListener';
import ContentUserProvider from 'context/3cat/ContentUserProvider';
import GlobalVarsProvider from 'context/GlobalVarsProvider';
import HistoryProvider from 'context/3cat/HistoryProvider';
import LoadingProvider from 'context/3cat/LoadingProvider';
import ModulAvisProvider from 'context/ModulAvisProvider';
import ProducteProvider from 'context/3cat/ProducteProvider';
import ModalProvider from 'context/3cat/ModalProvider';
import PublicitatProvider from 'context/PublicitatProvider';
import RedlMetadataProvider from 'context/REDL/RedlMetadataProvider';
import ServicesProvider from 'context/ServicesProvider';
import UserDelivertyProvider from 'context/UserDelivertyProvider';
import { UserProvider, myMSALObj } from 'context/UserProvider';
import { GlobalAdobeTargetProvider } from 'context/GlobalAdobeTargetProvider';
import ViewportProvider from 'context/corporatiu/ViewportProvider';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import styles from '../../../web/styles/3cat/globals.module.scss';
//NO ELIMINAR lodash.legacy-interop EL NECESSITA TVCPLAYERCORE

const App3cat = ({ Component, pageProps }) => {
    const [queryClient] = useState(() => new QueryClient());
    const DynamicComponents = getDynamicComponents('3cat');
    const router = useRouter();

    // const showOnboarding = !('no_onb' in router.query);

    useEffect(() => {
        const initializeMsal = async () => {
            try {
                await myMSALObj.initialize();
            } catch (error) {
                console.error('Error initializing 3cat MSAL:', error);
            }
        };

        initializeMsal();
    }, []);

    return (
        <ProducteProvider>
            <ErrorBoundary>
                <GlobalVarsProvider>
                    <QueryClientProvider client={queryClient}>
                        <HistoryProvider>
                            <MsalProvider instance={myMSALObj}>
                                <LoadingProvider>
                                    <ServicesProvider>
                                        <UserProvider>
                                            <ModulAvisProvider>
                                                <ContentUserProvider>
                                                    <GlobalAdobeTargetProvider>
                                                        <ViewportProvider {...pageProps}>
                                                            <PublicitatProvider>
                                                                <ModalProvider>
                                                                    <AvisCookies {...pageProps} />
                                                                    <div id='__mainContent' className={styles.trescat}>
                                                                        <ServicesListener {...pageProps} />
                                                                        <Component
                                                                            {...pageProps}
                                                                            dynamicComponents={DynamicComponents}
                                                                        />
                                                                        <Loading />
                                                                    </div>
                                                                    <div id='app-modal' className={styles.trescat} />
                                                                    <Modal {...pageProps} />
                                                                    {process.env.isDev === 'true' && (
                                                                        <ReactQueryDevtools initialIsOpen={false} />
                                                                    )}
                                                                </ModalProvider>
                                                            </PublicitatProvider>
                                                        </ViewportProvider>
                                                    </GlobalAdobeTargetProvider>
                                                </ContentUserProvider>
                                            </ModulAvisProvider>
                                        </UserProvider>
                                    </ServicesProvider>
                                </LoadingProvider>
                            </MsalProvider>
                        </HistoryProvider>
                    </QueryClientProvider>
                </GlobalVarsProvider>
            </ErrorBoundary>
        </ProducteProvider>
    );
};

export default App3cat;
